import { Card, Empty, Progress, Spinner, lucideIcons } from '@round/creatorbase-ui';
import styles from './Audience.module.css';
import languages from 'utility/languages';
import { PhylloUserAnalyticsData } from '@round/api';
import { toDecimalPoint } from '@round/utils';
import { CSSProperties } from 'react';
import { LANGUAGE_COLOR } from './helpers';
import cn from 'classnames';

const { SearchXIcon, CircleAlertIcon } = lucideIcons;

type Props = {
    data: PhylloUserAnalyticsData['profile']['audience']['languages'];
    isLoading?: boolean;
    errorMessage: string | null;
};

const TopLanguages = ({ data, isLoading, errorMessage }: Props) => {
    const isError = !!errorMessage;
    return (
        <Card size="sm" variant="borderless" className={styles.chartContainer}>
            <Card.Header className={styles.chartHeader}>
                <Card.Title>Top Languages</Card.Title>
            </Card.Header>
            <Card.Content className={cn(styles.chartContent, styles.languages)}>
                {isLoading && (
                    <div className={styles.spinnerContainer}>
                        <Spinner className={styles.spinner} />
                    </div>
                )}

                {!isLoading && data.length === 0 && (
                    <Empty>
                        <Empty.Media variant="icon">{isError ? <CircleAlertIcon /> : <SearchXIcon />}</Empty.Media>
                        <Empty.Title>{isError ? 'Something went wrong' : 'No data available'}</Empty.Title>
                        <Empty.Description>
                            {isError
                                ? errorMessage ?? 'Failed to load languages. Please try again.'
                                : 'Please try again later.'}
                        </Empty.Description>
                    </Empty>
                )}

                {!isLoading &&
                    data
                        .sort((a, b) => b.value - a.value)
                        .slice(0, 5)
                        .map((language) => (
                            <div key={language.code} className={styles.languageItem}>
                                <div className={styles.languageItemLabel}>
                                    <p>{languages[language.code]?.name}</p>
                                    <p className={styles.languageItemValue}>{toDecimalPoint(language.value, 2)}%</p>
                                </div>

                                <Progress
                                    value={language.value}
                                    className={styles.languageItemProgress}
                                    style={{ '--progress-indicator-color': LANGUAGE_COLOR } as CSSProperties}
                                />
                            </div>
                        ))}
            </Card.Content>
        </Card>
    );
};

export default TopLanguages;
